// US crisis resources for the AT_RISK / PROMOTION safety panel (TRIL-247).
// v1 US-only; localization deferred.
export interface CrisisResource {
  label: string;
  contact: string;
  href?: string;
}

export const CRISIS_RESOURCES: CrisisResource[] = [
  {
    label: '988 Suicide & Crisis Lifeline',
    contact: 'Call or text 988',
    href: 'tel:988',
  },
  {
    label: 'Crisis Text Line',
    contact: 'Text HOME to 741741',
    href: 'sms:741741',
  },
];
